import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { MatAutocompleteModule } from '@angular/material/autocomplete'
import { MatBadgeModule } from '@angular/material/badge'
import { MatButtonModule } from '@angular/material/button'
import { MatCardModule } from '@angular/material/card'
import { MatCommonModule } from '@angular/material/core'
import { MatDatepickerModule } from '@angular/material/datepicker'
import { MatDialogModule } from '@angular/material/dialog'
import { MatFormFieldModule } from '@angular/material/form-field'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatPaginatorModule } from '@angular/material/paginator'
import { MatProgressBarModule } from '@angular/material/progress-bar'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { MatSortModule } from '@angular/material/sort'
import { MatTableModule } from '@angular/material/table'
import { BrowserModule } from '@angular/platform-browser'
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { RouterModule } from '@angular/router'
import { TablerIconsModule } from 'angular-tabler-icons'
import * as TablerIcons from 'angular-tabler-icons/icons'
import { CocinaRoutingModule } from './cocina-routing.module'
import { CocinaComponent } from './cocina.component'
import { DetalleMenuComponent } from './detalle-menu/detalle-menu.component'
import { DialogAgregarPlatoComponent } from './detalle-menu/dialog-agregar-plato/dialog-agregar-plato.component'
import { DetallePlatoComponent } from './detalle-plato/detalle-plato.component'
import { DialogAgregarInsumoComponent } from './detalle-plato/dialog-agregar-insumo/dialog-agregar-insumo.component'
import { DialogMenuComponent } from './menus/dialog-menu/dialog-menu.component'
import { MenusComponent } from './menus/menus.component'
import { DialogPlatosComponent } from './platos/dialog-platos/dialog-platos.component'
import { PlatosComponent } from './platos/platos.component'
import { DialogSkusComponent } from './skus/dialog-skus/dialog-skus.component'
import { SkusComponent } from './skus/skus.component'

@NgModule({
  declarations: [
    SkusComponent,
    MenusComponent,
    CocinaComponent,
    PlatosComponent,
    DialogSkusComponent,
    DialogMenuComponent,
    DetalleMenuComponent,
    DetallePlatoComponent,
    DialogPlatosComponent,
    DialogAgregarPlatoComponent,
    DialogAgregarInsumoComponent
  ],
  imports: [
    FormsModule,
    RouterModule,
    CommonModule,
    MatCardModule,
    MatSortModule,
    MatIconModule,
    BrowserModule,
    MatBadgeModule,
    MatTableModule,
    MatInputModule,
    MatDialogModule,
    MatSelectModule,
    MatCommonModule,
    MatButtonModule,
    MatPaginatorModule,
    MatFormFieldModule,
    MatDatepickerModule,
    CocinaRoutingModule,
    ReactiveFormsModule,
    MatProgressBarModule,
    MatAutocompleteModule,
    BrowserAnimationsModule,
    MatProgressSpinnerModule,
    TablerIconsModule.pick(TablerIcons)
  ]
})
export class CocinaModule {}
